import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_DIPLOMAS_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_DIPLOMAS_TRANSLATION_KEY, {
  DIPLOMAS_TITLE: 'Your diplomas',
  SEE_ALL: 'See all',
  EMPTY_VIEW_TITLE: "You haven't earned any diplomas or participation certificates yet.",
  EMPTY_VIEW_DESC: 'To earn a diploma, you must complete an Academy path, and to earn participation certificates from Crehana, you just need to complete 100% of your class views.',
  EMPTY_VIEW_BUTTON: 'Go to my courses',
  EMPTY_VIEW_BUTTON_PROJECT: 'Go to my projects',
  EMPTY_VIEW_DEGREE_DESC: 'Once you complete all the courses and submit your partial projects, you will need to advance your final project and pass it to obtain your MicroDegree diploma.',
  EMPTY_VIEW_DEGREE_BUTTON: 'Go to my MicroDegree',
  DOWNLOAD_FILTER: 'Certification type',
  DOWNLOAD_FILTER_ALL: 'All ({{count}})',
  DOWNLOAD_FILTER_DIPLOMA: 'Diplomas ({{count}})',
  DOWNLOAD_FILTER_PROOF: 'Certificates ({{count}})',
  DOWNLOAD_DIPLOMA: 'DIPLOMA',
  DOWNLOAD_PROOF: 'CERTIFICATE',
  DOWNLOAD_DESCRIPTION_GENERAL: 'In total, you have achieved {{diplomasCount}} diplomas and {{certificateCount}} participation certificates.'
});